// @see https://www.awaresystems.be/imaging/tiff/tifftags/privateifd/exif/usercomment.html
export function decodeUserCommentExif(_userComment: Uint8Array): string {
    if (_userComment.length === 0) {
        return "";
    }
    const userComment = [..._userComment];
    const characterCode = userComment.splice(0, 8);

    const ASCII = [0x41, 0x53, 0x43, 0x49, 0x49, 0x00, 0x00, 0x00];
    if (characterCode.length !== ASCII.length || !ASCII.every((value, index) => characterCode[index] === value)) {
        return null;
    }

    return String.fromCharCode.apply(null, userComment);
}